import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_bin_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  bin_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  mrp_bin_type: fromDatatype.VarcharDatatypeInterface;
  reservation_status: fromDatatype.VarcharDatatypeInterface;
  total_reservation_qty: fromDatatype.NumericDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  length_marking_json: any;
  posting_status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_inv_bin_hdr_RowClass implements bl_inv_bin_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  bin_type: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.TextDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  qty_balance: fromDatatype.NumericDatatypeInterface;
  mrp_bin_type: fromDatatype.VarcharDatatypeInterface;
  reservation_status: fromDatatype.VarcharDatatypeInterface;
  total_reservation_qty: fromDatatype.NumericDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  length_marking_json: any;
  posting_status: fromDatatype.VarcharDatatypeInterface;
}
